
// Define the care plan fields
export const carePlanFields = [
    // "client_name",
    // "dob",
    // "gender",
    // "address",
    // "phone",
    // "email",
    "care_plan_start_date",
    "care_plan_end_date",
    "fall_risk",
    "infectious_diseases",
    "substance_use_considerations",
    "allergy_food",
    "allergy_medication",
    "allergy_environmental",
    // "dnr_order",
    // "dnr_copy_attached",
    "precautions_description",
    "precautions_related_notes",
    "precautions_general_notes",
    // "client_services",
    // "frequency",
    "care_plan_created_at",
    "care_plan_updated_at",
    "care_plan_created_by",
    "care_plan_updated_by",
    "client_services_gen_notes",
    "nutrition_goals_type",
    "nutrition_goals_description",
    "nutrition_goals_diagnosis",
    "medication_goals_timing",
    "medication_goals_supervision",
    "personal_goals_hygiene",
    "personal_goals_self_care",
    "skin_goals_wound",
    "skin_goals_reporting",
    "skin_goals_notes",
    "dietary_goals_frequency",
    "dietary_goals_special_requirement",
    "housekeeping_daily_task",
    "housekeeping_assistance_level",
    "ambulance_support_type",
    "ambulance_pain_monitoring",
    "bathing_frequency",
    "bathing_supervision_level",
    "toileting_frequency",
    "toileting_hygiene",
    "toileting_notes",
    // "mobility_level",
    // "mobility_notes",
    // "communication_notes",
    // "cognitive_concerns",
    // "cognitive_notes",
    "cognitive_general_notes",
    "home_env_pets",
    "home_env_accessibility_issues",
    "home_env_safety",
    "home_env_notes",
    "personal_cultural_practice",
    "personal_hobbies",
    "personal_social",
    "personal_notes",
    "doc_progress_notes",
    "doc_incident_reports",
    "review_changes_notes",
    "review_new_goals",
    "review_general_notes",
  ];
  
  // Function to extract care plan data from the form data
  export const extractCarePlanData = (formData) => {
    const carePlanData = {};
    carePlanFields.forEach((field) => {
      if (formData[field] !== undefined) {
        carePlanData[field] = formData[field];
      }
    });
    return carePlanData;
  };
  
  // Function to remove care plan fields from the project data
  export const removeCarePlanFields = (formData) => {
    const projectData = { ...formData };
    carePlanFields.forEach((field) => {
      delete projectData[field];
    });
    return projectData;
  };